import React, { useState, useEffect } from 'react'
import api from '../components/api'


const Modal = (props) => {


    var login_id = props.login_id
    var nome = props.nome


    var [senha, setSenha] = useState('')
    var [confirmaSenha, setConfirmaSenha] = useState('')


    function salvar() {


        if (senha != confirmaSenha) {

            window.toastr.error('Senhas não conferem!')
            return false

        } else {


            if (senha.length <= 4) {

                window.toastr.error('A senha precisa ter no mínimo 5 caracteres!')
                return false
            }

            const regex = /[0-9]/;
            
            if (!regex.test(senha)) {

                window.toastr.error('A senha precisa ter ao menos um caractere numérico!')
                return false

            } else {

                const regex = /[A-Z]/;
                if (!regex.test(senha)) {

                    window.toastr.error('A senha precisa ter ao menos uma letra maiúscula!')
                    return false

                } else {

                    //let regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
                    //let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{5,}$/
                    //let regex = "^[a-zA-Z0-9!@#$&()\\-`.+,/\"]*$"
                    let regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{5,})")

                    if (!regex.test(senha)) {

                        window.toastr.error('Sua senha precisa ter ao menos um caractere especial!')
                        return false

                    }

                }
                
            }

        }



        var dataPost = {

            senha: senha,

        }


        window.$.confirm({
            //icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
            title: 'Confirmação',
            content: 'Confirma alterar a senha?',
            buttons: {
                Sim: function () {


                    api.put(`senha/${login_id}`, dataPost).then((result) => {

                        //console.log(result.data)
                        window.$("#modalAlteraSenha").modal('hide');
                        window.toastr.success('Salvo com sucesso!')

                                                
            
                    }).catch((err) => {
            
                        console.log(err.response)
            
                    })


                   

                },
                Cancelar: function () {
                    //$.alert('Canceled!');
                }

            },

        });


    }

    


    return (

        <div>


                <div className="modal fade" id="modalAlteraSenha" tabindex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Alterar senha</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">
                                        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Senha</label>
                                                <input type="password" class="form-control" placeholder="" value={senha} onChange={event => setSenha(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Confirma senha</label>
                                                <input type="password" class="form-control" placeholder="" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                                
                                            </div>
                                        </div>



                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )

}


export default Modal